import { useEffect, useState } from "react";
import { MEDIA } from "../lib/media";
import { LISTEN_NOW } from "../lib/links";
import LetterReveal from "./LetterReveal";

export default function Hero() {
  const [loaded, setLoaded] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 80);
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      clearTimeout(t);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const openListenNow = () => {
    window.open(LISTEN_NOW, "_blank", "noopener,noreferrer");
  };

  return (
    <section
      data-testid="hero-section"
      className="relative h-screen w-full overflow-hidden bg-white"
    >
      {/* Image */}
      <div
        className="absolute inset-0"
        style={{ transform: `translateY(${scrollY * 0.2}px)` }}
      >
        <img
          src={MEDIA.hero}
          alt="Sylas Ever"
          className="w-full h-full object-cover"
          style={{ objectPosition: "center 18%" }}
        />
      </div>

      {/* Minimal gradient: just enough to read white text */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-black/45 pointer-events-none" />

      {/* Content — bottom-anchored, generous whitespace */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-20 md:pb-28 px-6 md:px-12 lg:px-20">
        <div
          className={`max-w-3xl transition-all duration-[1200ms] ${
            loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div data-testid="hero-era" className="mb-6">
            <span className="font-mono-meta text-[11px] tracking-[0.32em] uppercase text-white/90">
              Sylas Ever
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-serif-display text-white text-[14vw] sm:text-[10vw] md:text-[7vw] lg:text-[6vw] leading-[0.95] tracking-tight"
          >
            <LetterReveal
              text="Only You"
              italicWords={["Only"]}
              runOnMount
              delayBase={300}
              stepMs={70}
            />
          </h1>

          <p
            data-testid="hero-tagline"
            className="mt-6 max-w-md font-serif-display italic text-white/90 text-lg md:text-xl leading-relaxed"
          >
            New single. Out now.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-listen-button"
              onClick={openListenNow}
              className="btn-on-image"
            >
              Listen Now
            </button>
            <button
              onClick={() => document.getElementById("presave")?.scrollIntoView({ behavior: "smooth" })}
              data-testid="hero-presave-button"
              className="font-mono-meta text-[11px] tracking-[0.32em] uppercase text-white/90 hover:text-white link-underline"
            >
              Pre-save the next single →
            </button>
          </div>
        </div>
      </div>

      {/* Bottom-right scroll marker */}
      <div
        className={`absolute bottom-8 right-6 md:right-12 z-10 transition-opacity duration-[1500ms] delay-[800ms] ${
          loaded ? "opacity-70" : "opacity-0"
        }`}
        data-testid="hero-scroll-indicator"
      >
        <div className="font-mono-meta text-[10px] tracking-[0.4em] uppercase text-white">
          scroll ↓
        </div>
      </div>
    </section>
  );
}
